import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import {
  FullCalendarComponent,
  FullCalendarModule,
} from '@fullcalendar/angular';
import thLocale from '@fullcalendar/core/locales/th.js';
import dayGridPlugin from '@fullcalendar/daygrid/index.js';
import interactionPlugin from '@fullcalendar/interaction/index.js';

import { CalendarOptions } from '@fullcalendar/core/index.js';
import { Observable } from 'rxjs';
import { ScreenService } from '../../service/helper/screen.service';
@Component({
  selector: 'app-calendar',
  imports: [CommonModule, FullCalendarModule],
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.scss'
})
export class CalendarComponent {
  @ViewChild('fc') fc!: FullCalendarComponent;

  selectedMonth = new Date().getMonth();
  selectedYearBE = new Date().getFullYear() + 543;
  yearOptionsBE: number[] = [];


  calendarOptions!: CalendarOptions;


  isMobile$!: Observable<boolean>;

  constructor(
    private screenService: ScreenService,
  ) {
    this.isMobile$ = this.screenService.isMobile$();

    const nowBE = this.selectedYearBE;
    for (let y = nowBE - 5; y <= nowBE + 5; y++) this.yearOptionsBE.push(y);

    this.initCalendarOptions();
  }

  private initCalendarOptions() {
    this.calendarOptions = {
      plugins: [dayGridPlugin, interactionPlugin],
      initialView: 'dayGridMonth',
      locale: thLocale,
      headerToolbar: false,
      firstDay: 0,
      weekends: true,
      height: 'auto',
      expandRows: true,
      selectable: true,
      dayHeaderContent: (arg) => {
        const formatter = new Intl.DateTimeFormat('th-TH', { weekday: 'long' });
        let text = formatter.format(arg.date);
        if (text.startsWith('วัน')) {
          text = text.substring(3);
        }
        return { html: `<span>${text}</span>` };
      },
      datesSet: () => this.syncFromCalendar(),
      dateClick: (info) => {
        const dayOfWeek = info.date.getDay();
        if (dayOfWeek === 0 || dayOfWeek === 6) {
          return;
        }

        // this.openDayOffForm(info);
      },
      eventClick: (clickInfo) => {
        let clickEvent = clickInfo.event;
        const getId = clickEvent.id ? Number(clickEvent.id) : null;
        // this.openDayOffForm(null, getId, true);
      },
      // events: this.getEventsCalender.bind(this),
      // eventsSet: this.handleEventsSet.bind(this),
      dayMaxEventRows: true,
      eventDisplay: 'block',
      timeZone: 'UTC',
    };
  }

  private syncFromCalendar() {
    const d = this.fc.getApi().getDate();
    this.selectedMonth = d.getMonth();
    this.selectedYearBE = d.getFullYear() + 543;
  }
}
